import 'isomorphic-fetch';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { Integrations } from '@sentry/tracing';
import Main from '@components/Main';
import * as Sentry from '@sentry/react';
import store from '@store/index.js';

import './styles/style.css';

const SentryRoute = Sentry.withSentryRouting(Route);

try {
  Sentry.init({
    dsn: '__SENTRY_DSN__',
    environment: '__SENTRY_ENVIRONMENT__',
    release: RELEASE || '',
    ignoreErrors: ['ResizeObserver loop'],
    integrations: [
      new Integrations.BrowserTracing({
        traceFetch: false,
        traceXHR: false,
      }),
    ],
  });
} catch (e) {}

const root = ReactDOM.createRoot(document.getElementById('mfc'));
root.render(
  <Sentry.ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <SentryRoute path="/services/centry-gosudarstvennyh-uslug/:slug?">
          <Main />
        </SentryRoute>
      </BrowserRouter>
    </Provider>
  </Sentry.ErrorBoundary>
);
